import React, { Component } from 'react';
import '../styles/vod-info-label.css';

class VODInfoLabel extends Component {
    
    constructor(props) {
        super(props);
    }

    render() {
        return (
            <div className="vod-info-label-container">
                <div className="vod-info-label-container-flex">
                    <div ref="vodEventTitle" className="vod-info-label-container-channeltitle"></div>
                </div>
            </div>
        )
    }
}

export default VODInfoLabel;


// WEBPACK FOOTER //
// ./src/playerDomain/components/common/VODInfoLabel.js